import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CustomAddModal = (props) => {


    return (
        <>
            <Modal show={props.visible} onHide={props.close} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-white">{props.modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.modalContent}                    
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CustomAddModal;
